module.exports = __webpack_public_path__ + "img/icon-report.115b2875.png";